import { Component } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
} from '@angular/forms';






import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { interval, Subject, takeUntil } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { IAOnSpotResponseModel } from '../../../../../shared/models/IAOnSpotParticipantDetails';
import { ApiService } from '../../../../../shared/services/api.service';
import { AutofilliaService } from '../../../../../shared/services/autofillia.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { PastEventDetail } from '../../../../../shared/models/IAOnspot';
import { co } from '@fullcalendar/core/internal-common';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-onspotregistration',
  templateUrl: './onspotregistration.component.html',
  styleUrl: './onspotregistration.component.css',
})
export class OnspotregistrationComponent {
  
  isOtpFlow = true;
  public isSubmitted: boolean = false;
  isEditMode: boolean = false;
  length: number = 0;
  reportData: any[] = [];
  registrationStatus: boolean = false;
  documents: { name: string; file: File | null }[] = [];
  fileUrl: string | null = null;
  buttonText: string = 'Save';
  formData: any;
  OnSpotList: any[] = [];
  uploadError: string | null = null;
  certificateFile: File | null = null;
  certificateLicenseFile: File | null = null;
  certificateTradeFile: File | null = null;
  onSpotId: any;
  IndustryAssociationId: any;
  uniqueEventId: any;
  EventId: any;
  onSpotUserId: any;
  IAUserId: any;
  isButtonDisabled: boolean = false;
  emailOtpSent: boolean = false;
  isVerifyEmailOtpButtonDisabled: boolean = true;
  isButtonEmailDisabled: boolean = false;
  otpError: boolean = false;
  otpSuccess: boolean = false;
  resendMobileOtpDisabled: boolean = true;
  mobileOtpTimerRunning: boolean = false;
  mobileOtpTimer: number = 300;

  isVerifyButtonDisabled = true; // Initially disabled
  mobileResendCount = 1;
  maxResendAttempts: number = 5;

  countdown: number = 300;
  countdownDisplay: string | undefined;
  isResendButtonDisabled: boolean = true;
  countdownSubject: Subject<void> = new Subject<void>();
  mobileOtpTimerInterval: any;

  isDisabled: boolean = true;
  isChecked: boolean = true; // Default checked state

  isVerified: boolean = false; // New variable to track verification status

  socialCategory!: string;
  gender!: string;

  isUdyamAvailable: boolean = true; // Default is Yes
  filteredInterests: any[] = [];
  selectedParticipant: {
    participantName: string;
    participantDesignation: string;
    participantEmail: string;
    participantMobile: string;
    isEdited?: boolean;
  }[] = [];

  loadingSequence: boolean = false;

  usr_object!: IAOnSpotResponseModel;
  //hasUdyamNumber: boolean = false;  // Variable to track Udyam selection

  participantList: any[] = []; // Array to store records
  editingIndex: number | null = null;
  isSendButtonDisabled: boolean = false;
  isButtonMobileDisabled: boolean = false;
  registrationError: { typeError: boolean; sizeError: boolean } = {
    typeError: false,
    sizeError: false,
  };
  licenseError: { typeError: boolean; sizeError: boolean } = {
    typeError: false,
    sizeError: false,
  };
  tradeError: { typeError: boolean; sizeError: boolean } = {
    typeError: false,
    sizeError: false,
  };

  // Properties for popup (NEW)
  showPopup: boolean = false;
  popupTitle: string = '';
  popupMessage: string = '';
  pastEventsData: PastEventDetail[] = [];

  form = new FormGroup({
    onSpotUserId: new FormControl(''),
    enterpriseName: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
    ]), // Validators.pattern(this.common.enterpriseNamePattern)]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'),
    ]),
    gstNumber: new FormControl('', [
      Validators.pattern(
        '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z][0-9A-Z]{1}$',
      ),
      Validators.minLength(15),
    ]),
    mobotp: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
      Validators.pattern('^[0-9]+$'),
    ]),

    registrationUnderShopsAndEstbmtActCertificate: new FormControl(null),
    licenseUnderFactoriesActCertificate: new FormControl(null),
    tradeLicenseCertificate: new FormControl(null),

    registrationUnderShopsAndEstbmtActCertificateName: new FormControl(
      '' /*[Validators.required]*/,
    ),
    licenseUnderFactoriesActCertificateName: new FormControl(
      '' /*[Validators.required]*/,
    ),
    tradeLicenseCertificateName: new FormControl('' /*[Validators.required]*/),
    //path
    registrationUnderShopsAndEstbmtActCertificatePath: new FormControl(null),
    licenseUnderFactoriesActCertificatePath: new FormControl(null),
    tradeLicenseCertificatePath: new FormControl(null),
    udyamNumber: new FormControl<string | null>('UDYAM-MH-', [
      Validators.required,
      Validators.pattern(this.commonService.udyamNumber),
    ]),

    mobileNo: new FormControl(null),

    isRAMPRegistered: new FormControl(false),

    newParticipants: this.fb.array([]),
  });

  formWithoutOtp = new FormGroup({
    onSpotUserId: new FormControl(''),

    enterpriseName: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
    ]),

    email: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'),
    ]),

    gstNumber: new FormControl('', [
      Validators.pattern(
        '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z][0-9A-Z]{1}$',
      ),
      Validators.minLength(15),
    ]),

    udyamNumber: new FormControl<string | null>('UDYAM-MH-', [
      Validators.required,
      Validators.pattern(this.commonService.udyamNumber),
    ]),

    mobileNo: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[1-9][0-9]{9}$'),
    ]),

    isRAMPRegistered: new FormControl(false),

    // Documents
    registrationUnderShopsAndEstbmtActCertificate: new FormControl(null),
    licenseUnderFactoriesActCertificate: new FormControl(null),
    tradeLicenseCertificate: new FormControl(null),

    registrationUnderShopsAndEstbmtActCertificateName: new FormControl(''),
    licenseUnderFactoriesActCertificateName: new FormControl(''),
    tradeLicenseCertificateName: new FormControl(''),

    registrationUnderShopsAndEstbmtActCertificatePath: new FormControl(null),
    licenseUnderFactoriesActCertificatePath: new FormControl(null),
    tradeLicenseCertificatePath: new FormControl(null),

    newParticipantsWithoutOtp: this.fb.array([]),
  });

  constructor(
    private router: Router,
    private ia_serv: AutofilliaService,
    private apiService: ApiService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private common: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
      private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.EventId = sessionStorage.getItem('EventId');
    this.IAUserId = sessionStorage.getItem('industryAssociationUserId');
    this.form.get('registrationUnderShopsAndEstbmtActCertificate')?.disable();
    this.form.get('licenseUnderFactoriesActCertificate')?.disable();
    this.form.get('tradeLicenseCertificate')?.disable();
    const mode = this.route.snapshot.queryParamMap.get('mode'); // Example: ?mode=edit
    this.isEditMode = mode === 'edit';
    this.isDisabled = false;
    if (this.isEditMode) {
      this.otpSuccess = false;
      this.isDisabled = true;
      this.LoadOnSpotRegistrationDetails();
      this.LoadOnSpotRegistrationDetailswithoutOtp();
    } else {
      this.isDisabled = this.isEditMode;
      // This block runs ONLY when NOT in edit mode (i.e., in Save/Create mode)
      // Initialize newParticipants FormArray with one participant by default for 'Save' mode
      if (this.newParticipants.length === 0) {
        // Ensure you only add if it's truly empty
        this.newParticipants.push(this.createParticipant());
      }
         if (this.newParticipantsWithoutOtp.length === 0) {
        // Ensure you only add if it's truly empty
        this.newParticipantsWithoutOtp.push(this.createParticipantwithoutOtp());
      }
    }

    this.form
      .get('udyamNumber')
      ?.valueChanges.subscribe((value: string | null) => {
        if (value && value.startsWith('UDYAM-MH-')) {
          const prefix = 'UDYAM-MH-';
          let formattedValue = value
            .slice(prefix.length)
            .replace(/[^0-9]/g, '');

          if (formattedValue.length > 2) {
            formattedValue = `${formattedValue.slice(0, 2)}-${formattedValue.slice(2)}`;
          }

          this.form
            .get('udyamNumber')
            ?.setValue(prefix + formattedValue, { emitEvent: false });
        } else if (value === null || value === '') {
          this.form
            .get('udyamNumber')
            ?.setValue('UDYAM-MH-', { emitEvent: false });
        }
      });
  }


  onUdyamInput(event: any) {

    
  let value = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');


    if (!value || value.trim() === '') {
    this.formWithoutOtp.get('udyamNumber')?.setValue('UDYAM-MH-', { emitEvent: false });
    return;
  }

  if (value.length > 5) value = value.slice(0, 5) + '-' + value.slice(5);
  if (value.length > 8) value = value.slice(0, 8) + '-' + value.slice(8);
  if (value.length > 11) value = value.slice(0, 11) + '-' + value.slice(11);

  this.formWithoutOtp.get('udyamNumber')?.setValue(value, { emitEvent: false });
}
  async LoadOnSpotRegistrationDetails(): Promise<void> {
    this.route.params.subscribe((params) => {
      this.onSpotUserId = params['onSpotUserId'];
    });

    this.apiService
      .getRequest(API_ENDPOINTS.IA.GETOnSpotRegistrationByUserId, {
        onSpotUserId: this.onSpotUserId,
      })
      .subscribe((result) => {
        if (result.status) {
          this.length = result['totalRecords'];

          // Ensure reportData is always an array
          this.reportData = Array.isArray(result.data)
            ? result.data
            : [result.data];

          // Ensure item1 exists
          const data = result.data?.item1 || {};

          // Ensure item2 is an array
          this.usr_object = {
            status: result.status,
            message: result.message,
            list2: Array.isArray(result.data?.item2) ? result.data.item2 : [],
          };

          if (this.form) {
            this.form.patchValue({
              onSpotUserId: this.onSpotUserId,
              enterpriseName: data?.enterpriseName || '',
              udyamNumber: data?.udyamNumber || '',
              email: data?.email || '',
              mobileNo: data?.mobileNo || '',
              gstNumber: data?.gstNumber || '',
              //mobileNumber: data?.mobileNumber || '',
              registrationUnderShopsAndEstbmtActCertificateName:
                data?.RegistrationUnderShopsAndEstbmtActCertificateName || '',
              licenseUnderFactoriesActCertificateName:
                data?.LicenseUnderFactoriesActCertificateName || '',
              tradeLicenseCertificateName:
                data?.TradeLicenseCertificateName || '',
            });
          }
          const participantDataArray = Array.isArray(result.data?.item2)
            ? result.data.item2
            : []; // <--- Declared here

          // --- Populate the newParticipants FormArray from item2 ---
          participantDataArray.forEach((participantItem: any) => {
            const participantGroup = this.createParticipant(); // Create a new FormGroup using your helper
            participantGroup.patchValue({
              ParticipantName: participantItem.participantName || '',
              ParticipantDesignation:
                participantItem.participantDesignation || '',
              ParticipantEmail: participantItem.participantEmail || '',
              ParticipantMobile: participantItem.participantMobile || '',
              enrollmentId: participantItem.enrollmentId || '',
            });
            this.newParticipants.push(participantGroup); // Add the patched FormGroup to the FormArray
          });

          if (result.data.item1['udyamNumber'] != null) {
            //this.form.get('udyamCheck')?.setValue(true);
            this.isChecked = true;
          } else {
            this.isChecked = false;
          }
        }
      });

   
  }

  async LoadOnSpotRegistrationDetailswithoutOtp(): Promise<void> {
    this.route.params.subscribe((params) => {
      this.onSpotUserId = params['onSpotUserId'];
    });

    this.apiService
      .getRequest(API_ENDPOINTS.IA.GETOnSpotRegistrationByUserId, {
        onSpotUserId: this.onSpotUserId,
      })
      .subscribe((result) => {
        if (result.status) {
          this.length = result['totalRecords'];

          // Ensure reportData is always an array
          this.reportData = Array.isArray(result.data)
            ? result.data
            : [result.data];

          // Ensure item1 exists
          const data = result.data?.item1 || {};

console.log(result.data?.item1?.isWithoutOtp);



// ✅ Store flag
const isWithoutOtp = result.data?.item1?.isWithoutOtp;

// ✅ Set flow
this.isOtpFlow = !isWithoutOtp;

          // Ensure item2 is an array
          this.usr_object = {
            status: result.status,
            message: result.message,
            list2: Array.isArray(result.data?.item2) ? result.data.item2 : [],
          };

          if (this.formWithoutOtp) {
            this.formWithoutOtp.patchValue({
              onSpotUserId: this.onSpotUserId,
              enterpriseName: data?.enterpriseName || '',
              udyamNumber: data?.udyamNumber || '',
              email: data?.email || '',
              mobileNo: data?.mobileNo || '',
              gstNumber: data?.gstNumber || '',
              //mobileNumber: data?.mobileNumber || '',
              registrationUnderShopsAndEstbmtActCertificateName:
                data?.RegistrationUnderShopsAndEstbmtActCertificateName || '',
              licenseUnderFactoriesActCertificateName:
                data?.LicenseUnderFactoriesActCertificateName || '',
              tradeLicenseCertificateName:
                data?.TradeLicenseCertificateName || '',
            });
          }
          const participantDataArray = Array.isArray(result.data?.item2)
            ? result.data.item2
            : []; // <--- Declared here

          // --- Populate the newParticipants FormArray from item2 ---
          participantDataArray.forEach((participantItem: any) => {
            const participantGroup = this.createParticipantwithoutOtp(); // Create a new FormGroup using your helper
            participantGroup.patchValue({
              ParticipantName: participantItem.participantName || '',
              ParticipantDesignation:
                participantItem.participantDesignation || '',
              ParticipantEmail: participantItem.participantEmail || '',
              ParticipantMobile: participantItem.participantMobile || '',
              enrollmentId: participantItem.enrollmentId || '',
            });
            this.newParticipantsWithoutOtp.push(participantGroup); // Add the patched FormGroup to the FormArray
          });

          if (result.data.item1['udyamNumber'] != null) {
            //this.form.get('udyamCheck')?.setValue(true);
            this.isChecked = true;
          } else {
            this.isChecked = false;
          }
        }
      });
  }

  changeButtonText(newText: string): void {
    this.buttonText = newText;
  }
  // Handle Udyam selection manually
  //onUdyamSelectionEditMode(value: boolean) {
  //  this.hasUdyamNumber = value;
  //}
  get f() {
    return this.form.controls;
  }

  get o() {
    return this.formWithoutOtp.controls;
  }

  textAndSpaceOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const target = event.target as HTMLInputElement;
    const currentValue = target.value;

    // Allow letters (A-Z, a-z) and a single space (not after another space)
    if (
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      (charCode === 32 && !currentValue.endsWith(' '))
    ) {
      // Space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }

  textAndSpaceAndDotOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const char = String.fromCharCode(charCode);
    const target = event.target as HTMLInputElement; // Get the input element
    const currentValue = target.value;

    // Allow letters (A-Z, a-z), single space, and dot (.)
    if (
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 46 || // Dot
      (charCode === 32 && !currentValue.endsWith(' '))
    ) {
      // Single space and not after another space
      return true;
    }

    // Block all other characters
    return false;
  }

  textSpaceAndSpecialCharOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow letters (A-Z, a-z), space (ASCII 32), and special characters
    if (
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) || // Lowercase letters
      charCode === 32 || // Space
      (charCode >= 33 && charCode <= 47) || // Special characters ! " # $ % & ' ( ) * + , - . /
      (charCode >= 58 && charCode <= 64) || // Special characters : ; < = > ? @
      (charCode >= 91 && charCode <= 96) || // Special characters [ \ ] ^ _ `
      (charCode >= 123 && charCode <= 126) // Special characters { | } ~
    ) {
      return true;
    }

    // Block numbers and any other restricted characters
    return false;
  }

  textOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      charCode > 31 &&
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122)
    ) {
      return false;
    }
    return true;
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberAndCapitalAlphabetsOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow numbers (0-9), uppercase letters (A-Z), and lowercase letters (a-z)
    if (
      (charCode >= 48 && charCode <= 57) || // Numbers
      (charCode >= 65 && charCode <= 90) || // Uppercase letters
      (charCode >= 97 && charCode <= 122) // Lowercase letters
    ) {
      // If the input is a lowercase letter, convert it to uppercase
      if (charCode >= 97 && charCode <= 122) {
        event.target.value += String.fromCharCode(charCode).toUpperCase();
        event.preventDefault(); // Prevent adding the original lowercase letter
      }
      return true;
    }

    // Block all other characters
    return false;
  }

  onRegistrationFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.certificateFile = input.files[0];

      // Reset errors
      this.registrationError = { typeError: false, sizeError: false };
      this.form
        .get('registrationUnderShopsAndEstbmtActCertificate')
        ?.setErrors(null);

      // Validate file type (Only PDF)
      if (this.certificateFile.type !== 'application/pdf') {
        this.registrationError.typeError = true;
      }

      // Validate file size (Max 10 MB)
      const maxSizeInBytes = 10 * 1024 * 1024; // Convert MB to Bytes
      if (this.certificateFile.size > maxSizeInBytes) {
        this.registrationError.sizeError = true;
      }

      // If validation passes, update form and preview
      if (
        !this.registrationError.typeError &&
        !this.registrationError.sizeError
      ) {
        this.form.patchValue({
          registrationUnderShopsAndEstbmtActCertificateName:
            this.certificateFile.name,
        });
      }
    } else {
      this.registrationError = { typeError: false, sizeError: false };
      this.uploadError = 'Please upload a file.';
    }
  }

  onLicenseFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.certificateLicenseFile = input.files[0];

      // Reset errors
      this.licenseError = { typeError: false, sizeError: false };
      this.form.get('licenseUnderFactoriesActCertificate')?.setErrors(null);

      // Validate file type (Only PDF allowed)
      if (this.certificateLicenseFile.type !== 'application/pdf') {
        this.licenseError.typeError = true;
      }

      // Validate file size (Max 10 MB)
      const maxSizeInBytes = 10 * 1024 * 1024; // Convert MB to Bytes
      if (this.certificateLicenseFile.size > maxSizeInBytes) {
        this.licenseError.sizeError = true;
      }

      // If validation passes, update form and preview
      if (!this.licenseError.typeError && !this.licenseError.sizeError) {
        this.form.patchValue({
          licenseUnderFactoriesActCertificateName:
            this.certificateLicenseFile.name,
        });

        this.form.get('licenseUnderFactoriesActCertificate')?.markAsTouched();
        this.form.get('licenseUnderFactoriesActCertificate')?.markAsDirty();
      }
    } else {
      this.licenseError = { typeError: false, sizeError: false };
      this.uploadError = 'Please upload a file.';
    }
  }

  onTradeFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.certificateTradeFile = input.files[0];

      // Reset errors
      this.tradeError = { typeError: false, sizeError: false };
      this.form.get('tradeLicenseCertificate')?.setErrors(null);

      // Validate file type (Only PDF allowed)
      if (this.certificateTradeFile.type !== 'application/pdf') {
        this.tradeError.typeError = true;
      }

      // Validate file size (Max 10 MB)
      const maxSizeInBytes = 10 * 1024 * 1024; // Convert MB to Bytes
      if (this.certificateTradeFile.size > maxSizeInBytes) {
        this.tradeError.sizeError = true;
      }

      // If validation passes, update form and preview
      if (!this.tradeError.typeError && !this.tradeError.sizeError) {
        this.form.patchValue({
          tradeLicenseCertificateName: this.certificateTradeFile.name,
        });

        this.form.get('tradeLicenseCertificate')?.markAsTouched();
        this.form.get('tradeLicenseCertificate')?.markAsDirty();
      }
    } else {
      this.tradeError = { typeError: false, sizeError: false };
      this.uploadError = 'Please upload a file.';
    }
  }

  prepareFormData(): FormData {
    const formData = new FormData();

    const IAUserId = sessionStorage.getItem('industryAssociationUserId');
    const EventId = sessionStorage.getItem('EventId');

    // Append IndustryAssociationId to FormData
    if (EventId) {
      formData.append('EventId', EventId); // Append the ID
    }


    Object.keys(this.form.value).forEach((key) => {
      if (key !== 'mobotp' && key !== 'newParticipants') {
        const value = this.form.get(key)?.value;

        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      }
    });

    // Append the file separately if it exists
    if (this.certificateFile) {
      formData.append(
        'registrationUnderShopsAndEstbmtActCertificateFile',
        this.certificateFile,
      );
    }
    if (this.certificateLicenseFile) {
      formData.append(
        'licenseUnderFactoriesActCertificateFile',
        this.certificateLicenseFile,
      );
    }

    if (this.certificateTradeFile) {
      formData.append('tradeLicenseCertificateFile', this.certificateTradeFile);
    }
  formData.append('IsWithoutOtp', 'false');
    this.newParticipants.controls.forEach(
      (participantGroup: AbstractControl, index: number) => {
        const participantFg = participantGroup as FormGroup;
        Object.keys(participantFg.value).forEach((key) => {
          const value = participantFg.get(key)?.value;

          if (value !== null && value !== undefined) {
            formData.append(
              `onspotRegistrationParticipantDetails[${index}][${key}]`,
              value,
            );
          }
        });
      },
    );

    return formData;
  }

  prepareFormDataWithoutOtp(): FormData {
    const formData = new FormData();

    const EventId = sessionStorage.getItem('EventId');

    // ✅ Append EventId
    if (EventId) {
      formData.append('EventId', EventId);
    }

    // ✅ Append form fields (same logic as old method)
    Object.keys(this.formWithoutOtp.value).forEach((key) => {
      if (key !== 'newParticipants') {
        const value = this.formWithoutOtp.get(key)?.value;

        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      }
    });

    // ✅ Append files
    if (this.certificateFile) {
      formData.append(
        'registrationUnderShopsAndEstbmtActCertificateFile',
        this.certificateFile,
      );
    }

    if (this.certificateLicenseFile) {
      formData.append(
        'licenseUnderFactoriesActCertificateFile',
        this.certificateLicenseFile,
      );
    }

    if (this.certificateTradeFile) {
      formData.append('tradeLicenseCertificateFile', this.certificateTradeFile);
    }

      formData.append('IsWithoutOtp', 'true');

    // ✅ Append participants (same as working code)
    this.newParticipantsWithoutOtp.controls.forEach(
      (participantGroup: AbstractControl, index: number) => {
        const participantFg = participantGroup as FormGroup;

        Object.keys(participantFg.value).forEach((key) => {
          const value = participantFg.get(key)?.value;

          if (value !== null && value !== undefined) {
            formData.append(
              `onspotRegistrationParticipantDetails[${index}][${key}]`,
              value,
            );
          }
        });
      },
    );

    return formData;
  }
  onEdit(onSpotUserId: any): void {
    const selectedState = this.OnSpotList.find(
      (Enter) => Enter.onSpotUserId === onSpotUserId,
    );
    sessionStorage.setItem('UpdateID', onSpotUserId);
    if (selectedState) {
      // Populate the form with selected district data
      this.form.patchValue({
        onSpotUserId: this.onSpotUserId,
        enterpriseName: selectedState.enterpriseName,
        email: selectedState.Email,
        gstNumber: selectedState.GSTNumber,
        mobileNo: selectedState.MobileNo,
        udyamNumber: selectedState.UdyamNumber,
        registrationUnderShopsAndEstbmtActCertificate:
          selectedState.RegistrationUnderShopsAndEstbmtActCertificate,
        licenseUnderFactoriesActCertificate:
          selectedState.LicenseUnderFactoriesActCertificate,
        tradeLicenseCertificate: selectedState.TradeLicenseCertificate,
      });
      //this.isEditing = true;

      this.changeButtonText('Update'); // Update the button text to "Update"
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  // Your existing onSubmit method
  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.toastr.error('Please fill in all required fields correctly.');
      console.log('Form is invalid. Errors:', this.form.errors);
      return;
    }

    // IMPORTANT: Ensure newParticipants has actual data before proceeding
    // For demonstration, assuming newParticipants will be populated
    if (this.newParticipants.length >= 1 && this.otpSuccess) {
      // Assuming otpSuccess is set correctly
      this.isSubmitted = true;
      const formDatas = this.prepareFormData();

      if (this.isEditMode) {
        this.updateOnSpotRegistration(formDatas);
      } else {
        this.saveOnSpotRegistration(formDatas);
      }
    } else {
      this.toastr.error('OTP not verified or participant not added');
      return;
    }
  }

  onSubmitWithoutOtp() {
    
    this.formWithoutOtp.markAllAsTouched();

    if (this.formWithoutOtp.invalid) {
      this.toastr.error('Please fill in all required fields correctly.');

      // 🔍 Find invalid fields
      Object.keys(this.formWithoutOtp.controls).forEach((key) => {
        const control = this.formWithoutOtp.get(key);

        if (control && control.invalid) {
          console.log(`❌ Field: ${key}`, control.errors);
        }
      });

      return;
    }

    if (this.newParticipantsWithoutOtp.length >= 1) {
      this.isSubmitted = true;
      const formDatas = this.prepareFormDataWithoutOtp();



console.log('---- FormData Debug Start ----');

(formDatas as any).forEach((value: any, key: string) => {
  console.log(key, value);
});

console.log('---- FormData Debug End ----');

      if (this.isEditMode) {
        this.updateOnSpotRegistrationwithoutOtp(formDatas);
      } else {
        this.saveOnSpotRegistrationwithoutOtp(formDatas);
      }
    } else {
      this.toastr.error('OTP not verified or participant not added');
      return;
    }
  }

  updateOnSpotRegistrationwithoutOtp(formDatas: FormData) {
    this.apiService
      .postRequest(API_ENDPOINTS.IA.UPDATEONSPOTREGISTRATION, formDatas)
      .subscribe((res) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.router.navigate(['/viewallonspotregistration/', this.EventId]);
        }
      });
  }

  saveOnSpotRegistration(formDatas: FormData) {
    this.apiService
      .postRequest(API_ENDPOINTS.IA.ONSPOTREGISTRATIONBYIA, formDatas)
      .subscribe(
        (res) => {
          if (res.status && res.data == null) {
            this.toastr.success(res.message);
            this.router.navigate(['/viewallonspotregistration/', this.EventId]);
          } else {
            // This is the new part for handling the XML data in the popup
            this.popupTitle = 'Registration Alert'; // A generic title for the popup
            this.popupMessage = res.message; // The message from the API

            if (res.data) {
              this.parseXmlData(res.data);
            } else {
              this.pastEventsData = []; // Clear previous data if no XML is returned
            }
            this.showPopup = true; // Show the popup
          }
        },
        (err) => {
          console.error('An error occurred during registration:', err);
          this.toastr.error('An error occurred, please try again.');
        },
      );
  }

  saveOnSpotRegistrationwithoutOtp(formDatas: FormData) {
    this.apiService
      .postRequest(API_ENDPOINTS.IA.ONSPOTREGISTRATIONBYIA, formDatas)
      .subscribe(
        (res) => {
          if (res.status && res.data == null) {
            this.toastr.success(res.message);
            this.router.navigate(['/viewallonspotregistration/', this.EventId]);
          } else {
            // This is the new part for handling the XML data in the popup
            this.popupTitle = 'Registration Alert'; // A generic title for the popup
            this.popupMessage = res.message; // The message from the API

            if (res.data) {
              this.parseXmlData(res.data);
            } else {
              this.pastEventsData = []; // Clear previous data if no XML is returned
            }
            this.showPopup = true; // Show the popup
          }
        },
        (err) => {
          console.error('An error occurred during registration:', err);
          this.toastr.error('An error occurred, please try again.');
        },
      );
  }

  parseXmlData(xmlString: string): void {
    this.pastEventsData = []; // Clear previous data
    try {
      const parser = new DOMParser(); // Use DOMParser for browser-native XML parsing
      const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

      // Check for parsing errors
      const errorNode = xmlDoc.getElementsByTagName('parsererror')[0];
      if (errorNode) {
        console.error('XML Parsing Error:', errorNode.textContent);
        this.toastr.error(
          'Could not display event details due to an XML parsing error.',
        );
        return;
      }

      const eventDetailNodes = xmlDoc.getElementsByTagName('PastEventDetail');

      for (let i = 0; i < eventDetailNodes.length; i++) {
        const node = eventDetailNodes[i];
        const eventDetail: PastEventDetail = {
          // Access attribute for InterventionId
          InterventionId: parseInt(
            node.getAttribute('InterventionId') || '0',
            10,
          ),

          // Access child elements for other properties
          EventId: node.getElementsByTagName('EventId')[0]?.textContent || '',
          EventName:
            node.getElementsByTagName('EventName')[0]?.textContent || '',
          EventDate:
            node.getElementsByTagName('EventDate')[0]?.textContent || '',
          InterventionName:
            node.getElementsByTagName('InterventionName')[0]?.textContent || '',
          InterestName:
            node.getElementsByTagName('InterestName')[0]?.textContent || '',
          NameOfOrganisation:
            node.getElementsByTagName('NameOfOrganisation')[0]?.textContent ||
            '', // NEW field
        };
        this.pastEventsData.push(eventDetail);
      }
    } catch (e) {
      console.error('Failed to parse XML data:', e);
      this.toastr.error('An error occurred while processing event details.');
    }
  }

  // Method to close the popup
  closePopup(): void {
    this.showPopup = false;
    this.pastEventsData = []; // Optional: Clear data when closing popup
    this.popupTitle = '';
    this.popupMessage = '';
  }

  updateOnSpotRegistration(formDatas: FormData) {
    this.apiService
      .postRequest(API_ENDPOINTS.IA.UPDATEONSPOTREGISTRATION, formDatas)
      .subscribe(
        (res) => {
          if (res.status) {
            this.toastr.success(res.message);
            this.router.navigate(['/viewallonspotregistration/', this.EventId]);
          }
          //else {
          //  //this.toastr.error(res.message);
          //}
        },
        //err => {
        //  this.toastr.error('An error occurred, please try again.');
        //}
      );
  }

  onReset() {
    this.router.navigate(['/viewallonspotregistration/', this.EventId]);
    //sessionStorage.clear();
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      },
    });
  }

  verifyOTP() {
    const otpdata = {
      OtpType: 'mobile',
      //  otpValue: '9890729158'
      OtpValue: this.form.controls.mobileNo.value,
      //OtpValue: '7777777777',
      Otp: this.form.controls.mobotp.value?.toString(),
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.VerifyOtp, otpdata).subscribe(
      (res) => {
        /*if (res.status)*/
        if (res.message === 'OTP verified successfully.') {
          this.toastrService.success(res.message);
          this.otpError = false;
          this.otpSuccess = true;

          // Enable "Resend OTP" button after successful verification

          // Disable "Send OTP" button after successful verification
          this.isSendButtonDisabled = true;
          this.isResendButtonDisabled = true; // Optional: Disable Resend OTP if needed
          this.isVerifyButtonDisabled = true; // Disable Verify OTP button

          //this.resendMobileOtpDisabled = false;  // Ensure this is explicitly set to false

          // Stop the timer after OTP verification
          this.stopMobileOtpTimerAfterVerify(); //commented

          //this.stopCountdown();//added to check the enable of resend button after countdown

          this.form.controls.mobotp.disable();
        } else {
          this.otpError = true;
          this.otpSuccess = false;
          //this.toastrService.error('Incorrect OTP. Please try again.');
        }
      },
      (error) => {
        //console.error('Error during mobile OTP verification:', error);
        //this.toastrService.error('An error occurred during OTP verification.');
        this.otpError = true;
        this.otpSuccess = false;
      },
    );
  }

  startMobileOtpTimer() {
    this.mobileOtpTimerRunning = true;
    this.mobileOtpTimer = 300; // Set timer to 5 minutes
    this.resendMobileOtpDisabled = true; // Disable Resend OTP initially

    // Store the interval ID
    this.mobileOtpTimerInterval = setInterval(() => {
      if (this.mobileOtpTimer > 0) {
        this.mobileOtpTimer--;
      } else {
        this.stopMobileOtpTimer();
        this.resendMobileOtpDisabled = false;
      }
    }, 1000);
  }

  stopMobileOtpTimerAfterVerify() {
    this.mobileOtpTimerRunning = false;
    this.resendMobileOtpDisabled = false; // Enable the Resend OTP button after timer ends
    //this.isResendButtonDisabled = false;
    clearInterval(this.mobileOtpTimerInterval); // Clear the interval reference
  }
  stopMobileOtpTimer() {
    this.mobileOtpTimerRunning = false;
    //this.resendMobileOtpDisabled = false; // Enable the Resend OTP button after timer ends
    this.isResendButtonDisabled = false;
    clearInterval(this.mobileOtpTimerInterval); // Clear the interval reference
  }

  resetCountdown() {
    this.stopCountdown();
    this.startResendCountdown(); // Start the countdown for the resend functionality
  }

  stopCountdown() {
    this.countdown = 0;
    this.isResendButtonDisabled = true; // Disable the resend button during countdown
    this.countdownSubject.complete(); // Complete the countdown subject
  }

  startResendCountdown() {
    this.isResendButtonDisabled = true; // Disable resend button while countdown is active
    this.countdown = 300; // Set to 5 minutes
    interval(1000)
      .pipe(takeUntil(this.countdownSubject))
      .subscribe(() => {
        if (this.countdown > 0) {
          this.countdown--;
          this.updateCountdownDisplay();
        } else {
          this.stopCountdown();
        }
      });
  }

  updateCountdownDisplay() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.countdownDisplay = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  // In your component
  sendOTP() {
    const formValues = this.form.getRawValue();

    if (!formValues.mobileNo) {
      this.toastrService.error('Please enter a valid mobile.');
      return; // Exit if mobile number is invalid
    }

    // Disable the "Send OTP" button once clicked
    //this.isSendButtonDisabled = true;

    const otpdata = {
      otpType: 'mobile',
      otpValue: this.form.controls.mobileNo.value,
      //  otpValue: '9890729158'
      //otpValue:'7777777777'
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
      (res) => {
        if (res.status) {
          // If OTP is successfully sent, reset the countdown and start the timer
          //this.resetCountdown(); // Reset countdown for resend
          this.startMobileOtpTimer(); // Start OTP timer
          this.toastrService.success('OTP has been sent successfully.');

          this.isVerifyButtonDisabled = false;
          this.isSendButtonDisabled = true;
        } else {
          // If OTP sending fails, show error
          this.toastrService.error(
            'Error while sending OTP. Please try again later.',
          );
        }
      },
      //error => {
      //  // Handle error scenario
      //  //console.error('Error sending OTP:', error);
      //  //this.toastrService.error('An error occurred while sending OTP.');
      //},
      () => {
        // Re-enable "Send OTP" button when the request is complete (success or failure)
        //this.isSendButtonDisabled = false;
      },
    );
  }

  resendOTP() {
    const formValues = this.form.getRawValue();

    if (!formValues.mobileNo) {
      this.toastrService.error('Please enter a valid mobile.');
      this.isResendButtonDisabled = false; // Enable Resend OTP button if error
      return;
    }

    if (this.mobileResendCount >= this.maxResendAttempts) {
      this.toastrService.warning(
        'You have reached the maximum resend attempts for mobile OTP today.',
        'Warning',
      );
      return;
    }

    this.mobileResendCount++;

    this.isResendButtonDisabled = true; // Disable "Resend OTP" button during resend

    const otpdata = {
      otpType: 'mobile',
      otpValue: this.form.controls.mobileNo.value,
      //otpValue: '8799974825'

      //  otpValue: '9890729158'
    };

    this.apiService.postRequest(API_ENDPOINTS.Otp.SendOtp, otpdata).subscribe(
      (res) => {
        if (res.status) {
          this.resetCountdown(); // Reset countdown for resend
          this.startMobileOtpTimer(); // Start OTP timer again
          this.toastrService.success('OTP has been resent successfully.');
          this.isResendButtonDisabled = true;
        } else {
          this.toastrService.error(
            'Error while resending OTP. Please try again later.',
          );
        }
      },
      //error => {
      //  console.error('Error resending OTP:', error);
      //  this.toastrService.error('An error occurred while resending OTP.');
      //},
      () => {
        // Re-enable "Resend OTP" button after the request completes (success or failure)
        this.isResendButtonDisabled = false;
      },
    );
  }

  verifyUdyam(udyamNumber: any, mobileNo: any) {
    if (!udyamNumber || !mobileNo) {
      this.toastrService.error(
        'Please provide both Udyam Registration Number and Mobile Number.',
      );
      return;
    }

    const formDatavalue = {
      udyamRegistrationNumber: udyamNumber,
      ownersMobileNumber: mobileNo,
      uniqueEventId: this.EventId,
    };

    const dtoUdyam = {
      authToken: '',
      clientId: '',
      udyamNo: udyamNumber,
      mobile: mobileNo,
    };

    this.ngxUiLoaderService.start();

    // FIRST API – Validate MSME User
    this.apiService
      .postRequest(API_ENDPOINTS.MSME.VALIDATEMSMEUSER, formDatavalue)
      .subscribe(
        (res) => {
          const message = res?.message?.trim()?.toUpperCase();

          //Already Enrolled
          if (res?.status && message === 'EN') {
            this.ngxUiLoaderService.stop();
            this.toastrService.error('User already enrolled');
            this.router.navigate(['/viewallonspotregistration/', this.EventId]);
            return;
          }

          if (res?.status && (message === 'UNF' || message === 'NE')) {
            this.loadingSequence = true;

            this.apiService
              .postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam)
              .pipe(finalize(() => this.ngxUiLoaderService.stop()))
              .subscribe(
                (response) => {
                  if (response?.isResponse === 'Y') {

                    console.log('Udyam verification response:', response); // Debug log
                    const gender = response?.data?.gender;
                    const socialCategory = response?.data?.socialCategory;

                    if (!this.isEligibleForEvent(gender, socialCategory)) {
                      this.loadingSequence = false;
                      this.toastrService.error(
                        'Enrollment allowed only for Female MSMEs (any category) or Male MSMEs from SC/ST category.',
                      );
                      return;
                    }

                    this.form.patchValue({
                      enterpriseName: response?.data?.nameOfEnterprise,
                      email: response?.data?.email,
                    });

                    if (message === 'NE') {
                      this.form.controls.isRAMPRegistered.setValue(true);
                    }

                    this.isVerified = true;
                    this.loadingSequence = false;
                  } else {
                    this.loadingSequence = false;
                    this.toastrService.error(
                      response?.msg || 'Udyam verification failed.',
                    );
                  }
                },
                () => {
                  this.loadingSequence = false;
                  this.ngxUiLoaderService.stop();
                  this.toastrService.error('Error during Udyam verification.');
                },
              );

            return;
          }

          this.ngxUiLoaderService.stop();
          this.toastrService.error('Data cannot be fetched');
          this.router.navigate(['/viewallonspotregistration/', this.EventId]);
        },
        () => {
          this.ngxUiLoaderService.stop();
          this.toastrService.error('Error validating MSME user.');
        },
      );
  }

  verifyUdyamwithoutOtp(udyamNumber: any, mobileNo: any) {
    if (!udyamNumber || !mobileNo) {
      this.toastrService.error(
        'Please provide both Udyam Registration Number and Mobile Number.',
      );
      return;
    }

    const formDatavalue = {
      udyamRegistrationNumber: udyamNumber,
      ownersMobileNumber: mobileNo,
      uniqueEventId: this.EventId,
    };

    const dtoUdyam = {
      authToken: '',
      clientId: '',
      udyamNo: udyamNumber,
      mobile: mobileNo,
    };

    this.ngxUiLoaderService.start();

    // FIRST API – Validate MSME User
    this.apiService
      .postRequest(API_ENDPOINTS.MSME.VALIDATEMSMEUSER, formDatavalue)
      .subscribe(
        (res) => {
          const message = res?.message?.trim()?.toUpperCase();

          //Already Enrolled
          if (res?.status && message === 'EN') {
            this.ngxUiLoaderService.stop();
            this.toastrService.error('User already enrolled');
            this.router.navigate(['/viewallonspotregistration/', this.EventId]);
            return;
          }

          if (res?.status && (message === 'UNF' || message === 'NE')) {
            this.loadingSequence = true;

            debugger;

            this.apiService
              .postRequest(API_ENDPOINTS.UDYAM.VERIFYUDYAM, dtoUdyam)
              .pipe(finalize(() => this.ngxUiLoaderService.stop()))
              .subscribe(
                (response) => {
                  if (response?.isResponse === 'Y') {
                    const gender = response?.data?.gender;
                    const socialCategory = response?.data?.socialCategory;

                    if (!this.isEligibleForEvent(gender, socialCategory)) {
                      this.loadingSequence = false;
                      this.toastrService.error(
                        'Enrollment allowed only for Female MSMEs (any category) or Male MSMEs from SC/ST category.',
                      );
                      return;
                    }

                    this.formWithoutOtp.patchValue({
                      enterpriseName: response?.data?.nameOfEnterprise,
                      email: response?.data?.email,
                    });

                    if (message === 'NE') {
                      this.formWithoutOtp.controls.isRAMPRegistered.setValue(
                        true,
                      );
                    }

                    this.isVerified = true;
                    this.loadingSequence = false;
                  } else {
                    this.loadingSequence = false;
                    this.toastrService.error(
                      response?.msg || 'Udyam verification failed.',
                    );
                  }
                },
                () => {
                  this.loadingSequence = false;
                  this.ngxUiLoaderService.stop();
                  this.toastrService.error('Error during Udyam verification.');
                },
              );

            return;
          }

          this.ngxUiLoaderService.stop();
          this.toastrService.error('Data cannot be fetched');
          this.router.navigate(['/viewallonspotregistration/', this.EventId]);
        },
        () => {
          this.ngxUiLoaderService.stop();
          this.toastrService.error('Error validating MSME user.');
        },
      );
  }

  private isEligibleForEvent(gender: string, socialCategory: string): boolean {
    const intervention = sessionStorage.getItem('Intervention');
    const component = sessionStorage.getItem('Component');

    // Apply rule only for specific Intervention & Component
    if (
      intervention === 'Capacity Building' &&
      component ===
        'Sensitization and Capacity Building for Women & SC/ST Entrepreneurs'
    ) {
      const normalizedGender = (gender || '').toUpperCase();
      const category = (socialCategory || '').toUpperCase();

      if (normalizedGender === 'NA') {
        return false;
      }

      if (normalizedGender === 'FEMALE') {
        return true;
      }

      if (normalizedGender === 'MALE') {
        return category === 'SC' || category === 'ST';
      }

      return false;
    }

    return true;
  }

  onUdyamSelection(value: boolean) {
    this.isUdyamAvailable = value;

    if (!value) {
      // Reset and disable UDYAM-related fields
      this.form.get('udyamNumber')?.reset();
      this.form.get('udyamNumber')?.disable();
      this.form.get('mobileNo')?.reset();
      this.form.get('mobileNo')?.disable();
      this.form.get('enterpriseName')?.reset();
      this.form.get('email')?.reset();
      this.form.get('mobileNumber')?.reset();
      this.form.get('gstNumber')?.reset();
      this.form.get('mobotp')?.reset();
      this.form.get('ParticipantName')?.reset();
      this.form.get('ParticipantDesignation')?.reset();
      this.form.get('ParticipantEmail')?.reset();
      this.form.get('ParticipantMobile')?.reset();

      // Enable and reset alternative registration fields
      this.form.get('registrationUnderShopsAndEstbmtActCertificate')?.reset();
      this.form.get('registrationUnderShopsAndEstbmtActCertificate')?.enable();
      this.form.get('licenseUnderFactoriesActCertificate')?.reset();
      this.form.get('licenseUnderFactoriesActCertificate')?.enable();
      this.form.get('tradeLicenseCertificate')?.reset();
      this.form.get('tradeLicenseCertificate')?.enable();
      this.form.reset();
      this.isSendButtonDisabled = false;
      this.stopMobileOtpTimer();
      this.form.controls.mobotp.enable();
      this.isVerifyButtonDisabled = true;
    } else {
      // Reset and enable UDYAM-related fields
      this.form.get('udyamNumber')?.reset();
      this.form.get('udyamNumber')?.enable();
      this.form.get('mobileNo')?.reset();
      this.form.get('mobileNo')?.enable();

      this.form.get('enterpriseName')?.reset();
      this.form.get('email')?.reset();
      this.form.get('mobileNumber')?.reset();
      this.form.get('gstNumber')?.reset();
      this.form.get('mobotp')?.reset();
      this.form.get('ParticipantName')?.reset();
      this.form.get('ParticipantDesignation')?.reset();
      this.form.get('ParticipantEmail')?.reset();
      this.form.get('ParticipantMobile')?.reset();

      // Reset and disable alternative registration fields
      this.form.get('registrationUnderShopsAndEstbmtActCertificate')?.reset();
      this.form.get('registrationUnderShopsAndEstbmtActCertificate')?.disable();
      this.form.get('licenseUnderFactoriesActCertificate')?.reset();
      this.form.get('licenseUnderFactoriesActCertificate')?.disable();
      this.form.get('tradeLicenseCertificate')?.reset();
      this.form.get('tradeLicenseCertificate')?.disable();
      //this.form.reset();
      this.isSendButtonDisabled = false;
      this.stopMobileOtpTimer();
      this.form.controls.mobotp.enable();
      this.isVerifyButtonDisabled = true;
    }
  }

  add(): void {
    if (this.participantList.length >= 5) {
      this.toastrService.error('You can add a maximum of 5 participants.');
      return;
    }
  }

  resetParticipantSelection(): void {
    this.form.get('ParticipantName')?.reset();
    this.form.get('ParticipantDesignation')?.reset();
    this.form.get('ParticipantEmail')?.reset();
    this.form.get('ParticipantMobile')?.reset();

    this.filteredInterests = [];
  }
  removeParticipant(index: number): void {
    // Confirm removal
    if (confirm('Are you sure you want to remove this Participant?')) {
      // Remove the Participant from the participantList array at the specified index
      this.participantList.splice(index, 1);
    }
  }

  editParticipant(index: number) {
    this.editingIndex = index;
    const participant = this.participantList[index];

    participant.isEdited = true;

    this.participantList.splice(index, 1);
  }

  get newParticipants(): FormArray {
    return this.form.get('newParticipants') as FormArray;
  }

  get newParticipantsWithoutOtp(): FormArray {
    return this.formWithoutOtp.get('newParticipantsWithoutOtp') as FormArray;
  }

  createParticipant(): FormGroup {
    return this.fb.group({
      ParticipantName: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern("^[a-zA-Z '\-]+$"),
        ],
      ],
      ParticipantDesignation: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
        ],
      ],
      ParticipantEmail: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(100)],
      ],
      ParticipantMobile: [
        '',
        [Validators.required, Validators.pattern('^[6-9]\\d{9}$')],
      ],
      enrollmentId: new FormControl(null),
      IsDeleted: [false], // Add this new control, initialized to false
    });
  }


  validateEmail(record: any) {
  const control = record.get('ParticipantEmail');

  if (control && control.value) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(control.value)) {
      control.setErrors({ email: true });
    } else {
      control.setErrors(null);
    }
  }
}
  createParticipantwithoutOtp(): FormGroup {
    return this.fb.group({
      ParticipantName: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
          Validators.pattern("^[a-zA-Z '\-]+$"),
        ],
      ],
      ParticipantDesignation: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
        ],
      ],
      ParticipantEmail: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(100)],
      ],
      ParticipantMobile: [
        '',
        [Validators.required, Validators.pattern('^[6-9]\\d{9}$')],
      ],
      enrollmentId: new FormControl(null),
      IsDeleted: [false], // Add this new control, initialized to false
    });
  }

  addMoreParticipants(): void {
    const newParticipants = this.form.get('newParticipants') as FormArray;

    if (newParticipants.length < 5) {
      newParticipants.push(this.createParticipant());
    } else {
      // Show Toastr notification
      this.toastr.warning(
        'Maximum 5 participants are allowed.',
        'Participant Limit Reached',
      );
    }
  }

  addMoreParticipantsWithoutOtp(): void {
    const newParticipantsWithoutOtp = this.formWithoutOtp.get(
      'newParticipantsWithoutOtp',
    ) as FormArray;

    if (newParticipantsWithoutOtp.length < 5) {
      newParticipantsWithoutOtp.push(this.createParticipantwithoutOtp());
    } else {
      // Show Toastr notification
      this.toastr.warning(
        'Maximum 5 participants are allowed.',
        'Participant Limit Reached',
      );
    }
  }

  removeNewParticipants(index: number): void {
    const newParticipants = this.form.controls.newParticipants as FormArray;

    if (index >= 0 && index < newParticipants.length) {
      const participantToRemove = newParticipants.at(index) as FormGroup;

      const isDeletedControl = participantToRemove.get('IsDeleted');

      const isNewAndEmpty = Object.keys(participantToRemove.controls).every(
        (key) => {
          const control = participantToRemove.get(key);
          return !control?.value || key === 'IsDeleted';
        },
      );

      const currentActiveParticipants = newParticipants.controls.filter(
        (control: AbstractControl) => {
          const isDeletedControl = (control as FormGroup).get('IsDeleted');
          return isDeletedControl ? !isDeletedControl.value : true; // Consider it active if IsDeleted is false or not present
        },
      ).length;

      if (currentActiveParticipants === 1 && !isDeletedControl?.value) {
        this.toastrService.info(
          'At least one participant record must be present.',
        );
        return;
      }

      if (isNewAndEmpty) {
        newParticipants.removeAt(index); // Completely remove it
      } else {
        participantToRemove.get('IsDeleted')?.setValue(true); // Soft delete
      }
    }
  }

  removeNewParticipantsWithoutOtp(index: number): void {
    const newParticipantsWithoutOtp = this.formWithoutOtp.controls
      .newParticipantsWithoutOtp as FormArray;

    if (index >= 0 && index < newParticipantsWithoutOtp.length) {
      const participantToRemove = newParticipantsWithoutOtp.at(
        index,
      ) as FormGroup;

      const isDeletedControl = participantToRemove.get('IsDeleted');

      const isNewAndEmpty = Object.keys(participantToRemove.controls).every(
        (key) => {
          const control = participantToRemove.get(key);
          return !control?.value || key === 'IsDeleted';
        },
      );

      const currentActiveParticipants =
        newParticipantsWithoutOtp.controls.filter(
          (control: AbstractControl) => {
            const isDeletedControl = (control as FormGroup).get('IsDeleted');
            return isDeletedControl ? !isDeletedControl.value : true; // Consider it active if IsDeleted is false or not present
          },
        ).length;

      if (currentActiveParticipants === 1 && !isDeletedControl?.value) {
        this.toastrService.info(
          'At least one participant record must be present.',
        );
        return;
      }

      if (isNewAndEmpty) {
        newParticipantsWithoutOtp.removeAt(index); // Completely remove it
      } else {
        participantToRemove.get('IsDeleted')?.setValue(true); // Soft delete
      }
    }
  }
selectedRegistrationType: boolean = true;

// ✅ Open from button click
changeRegistrationType(isOtp: boolean) {

  // ✅ Store selected value only
  this.selectedRegistrationType = isOtp;
}


// ✅ Confirm Change
confirmRegistrationTypeChange() {

  // ✅ Change flag
  this.isOtpFlow = this.selectedRegistrationType;

  // ✅ Reset OTP Form
  this.form.reset({
    onSpotUserId: '',
    enterpriseName: '',
    email: '',
    gstNumber: '',
    mobotp: '',
    registrationUnderShopsAndEstbmtActCertificate: null,
    licenseUnderFactoriesActCertificate: null,
    tradeLicenseCertificate: null,
    registrationUnderShopsAndEstbmtActCertificateName: '',
    licenseUnderFactoriesActCertificateName: '',
    tradeLicenseCertificateName: '',
    registrationUnderShopsAndEstbmtActCertificatePath: null,
    licenseUnderFactoriesActCertificatePath: null,
    tradeLicenseCertificatePath: null,
    udyamNumber: 'UDYAM-MH-',
    mobileNo: null,
    isRAMPRegistered: false
  });

  // ✅ Reset Without OTP Form
  this.formWithoutOtp.reset({
    onSpotUserId: '',
    enterpriseName: '',
    email: '',
    gstNumber: '',
    udyamNumber: 'UDYAM-MH-',
    mobileNo: null,
    isRAMPRegistered: false,
    registrationUnderShopsAndEstbmtActCertificate: null,
    licenseUnderFactoriesActCertificate: null,
    tradeLicenseCertificate: null,
    registrationUnderShopsAndEstbmtActCertificateName: '',
    licenseUnderFactoriesActCertificateName: '',
    tradeLicenseCertificateName: '',
    registrationUnderShopsAndEstbmtActCertificatePath: null,
    licenseUnderFactoriesActCertificatePath: null,
    tradeLicenseCertificatePath: null
  });

  // ✅ Clear participants
  this.newParticipants.clear();
  this.newParticipantsWithoutOtp.clear();

  // ✅ Add one default participant row
  this.newParticipants.push(
    this.createParticipant()
  );

  this.newParticipantsWithoutOtp.push(
    this.createParticipantwithoutOtp()
  );

  // ✅ Clear uploaded files
  this.certificateFile = null;
  this.certificateLicenseFile = null;
  this.certificateTradeFile = null;

  // ✅ Reset flags
  this.otpSuccess = false;
  this.isVerified = false;
  this.isSubmitted = false;

  // ✅ Success Message
  this.toastr.success(
    'Registration type changed successfully'
  );
}





}
